module.exports = __webpack_public_path__ + "img/sld_scb_15_t1_green.51a6d5cb.svg";